var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14.1431V11.1431M12.0002 11.1431V8.14307M12.0002 11.1431H9.00024M12.0002 11.1431H15.0002M7.12382 18.8442L5.59985 20.0634C4.76768 20.7291 4.3514 21.0622 4.00122 21.0625C3.69668 21.0629 3.40869 20.9244 3.2187 20.6864C3.00024 20.4127 3.00024 19.88 3.00024 18.8143V7.34326C3.00024 6.22316 3.00024 5.66269 3.21823 5.23486C3.40998 4.85854 3.71572 4.5528 4.09204 4.36105C4.51986 4.14307 5.08033 4.14307 6.20044 4.14307H17.8004C18.9205 4.14307 19.4803 4.14307 19.9081 4.36105C20.2845 4.5528 20.5907 4.85854 20.7825 5.23486C21.0002 5.66227 21.0002 6.22206 21.0002 7.33998V14.9466C21.0002 16.0646 21.0002 16.6235 20.7825 17.0509C20.5907 17.4273 20.2846 17.7335 19.9083 17.9253C19.4809 18.1431 18.9217 18.1431 17.8038 18.1431H9.1228C8.70677 18.1431 8.49853 18.1431 8.29956 18.1839C8.12304 18.2201 7.9524 18.2798 7.79193 18.3618C7.61173 18.4539 7.44988 18.5834 7.12747 18.8413L7.12382 18.8442Z",
    stroke: "#1F263E",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAddIcon);
export default __webpack_public_path__ + "static/media/chatAddIcon.f593ddb1c2db674fa701cf31c49518be.svg";
export { ForwardRef as ReactComponent };